import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useToken } from '../context/TokenContext';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { token, loading } = useToken();

  if (loading) {
    // You can replace this with a spinner component if you have one
    return <div>Loading...</div>;
  }

  if (!token) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
